import gql from 'graphql-tag';


export const add = gql`mutation CreateVessel($vessel: VesselInput!) {
    createVessel(vessel: $vessel) {
        id
        name
        year
    }
}`;

export const edit = gql`mutation EditVessel($id: ID!, $vessel: VesselInput!) {
    editVessel(id: $id, vessel: $vessel) {
        id
        name
        oldName
        year
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/vessel.js